import { DivisionValue, OrderType } from '../constants/Enum'

export const decodePrefixWc = (division) => {
  // 1&4 = TLT, 2&3 = HHD, G = HHD (G1-S17, G2-M14 ...)
  if (division === DivisionValue.TLT) return ['1', '4']
  else if (division === DivisionValue.HHD) return ['2', '3', 'G']
  return ['']
}

export const filterByType = (workCenters, type) => {
  const orderType = type === OrderType.BULK ? '1':'2'
  return workCenters.filter(wc => wc.id.slice(1,2) === orderType)
}